import { battleHistoryService } from "../../services/api";
import { BattleHistory } from "../../types/history/history";

let historyList: BattleHistory[] = [
  {
    orderID: 1,
    date: "2022",
    location: "Київська область",
    description:
      "Наші Бійці прийняли бій проти російського десанту на Київському водосховищі поблизу села Лютіж",
  },
  {
    orderID: 2,
    date: "2022",
    location: "Київська область",
    description: "Звільнили н.п. Шпитьки, Ясногородка, Мотижин і Вітрівка, Київської області",
  },
  {
    orderID: 3,
    date: "2022",
    location: "Київська область",
    description: "Влітку вели обороні дії в н.п. Соледар, Бондарне і Зайцеве",
  },
  {
    orderID: 4,
    date: "2022-2024",
    location: "Донецька область",
    description:
      "Вели одні з найуспішніших контрнаступальних дій і ефективно утримували звільнені позиції на Новопавлівському напрямку в районі стратегічно важливого н.п. Велика Новосілка",
  },
  {
    orderID: 5,
    date: "2023",
    location: "Донецька область",
    description: "Брали активну участь в обороні Бахмута і Кліщіївкі",
  },
  {
    orderID: 6,
    date: "2023-2024",
    location: "Харківська область",
    description: "Вели активні оборонні дії у н.п. Лиман Перший, Синьківка, Табаївка та Куп’янськ",
  },
  {
    orderID: 7,
    date: "2023-2025",
    location: "Київська область",
    description: "Тримаємо оборону неба столиці України. Знищуємо ворожі ракети та дрони",
  },
  {
    orderID: 8,
    date: "2024-2025",
    location: "Курська та Донецька області",
    description: "Ведемо успішні контрнаступальні дії на Курщині та Донеччині. Ефективно утримуємо зайняті позиції",
  },
];

export async function loadBattleHistory() {
  try {
    // Call the API to get all battle history entries
    const response = await battleHistoryService.getAll();

    // Extract the data from the response
    const newHistoryList: BattleHistory[] = response.data;

    // Sort by orderID before returning
    historyList = newHistoryList.sort((a, b) => a.orderID - b.orderID);
  } catch (error) {
    console.error("Failed to load battle history:", error);
    throw new Error("Не вдалося завантажити історію бойових дій");
  }
}

export function getBattleHistory() {
  return structuredClone(historyList).sort((a, b) => a.orderID - b.orderID);
}
